import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum FleetPermissionSet {
  View = 'fleet_view',
  New = 'fleet_new',
  Edit = 'fleet_edit',
  ForceEdit = 'fleet_force_edit',
}

// Ignore prettier to ensure only one permission per line
// prettier-ignore
export const fleetPermissionSetGrouping: IPermissionSetGrouping<FleetPermissionSet> = {
  key: PermissionSetGroupingKey.Fleet,
  active: {
    [FleetPermissionSet.View]: [
      PermissionType.GET_ANY_FLEET,
      PermissionType.LIST_ANY_FLEET,
      PermissionType.LIST_ANY_CUSTOM_FIELD,
    ],
    [FleetPermissionSet.New]: [
      PermissionType.POST_ANY_FLEET,
      PermissionType.WRITE_ANY_OPEN_FLEET_CONFIGURATION,
      PermissionType.WRITE_ANY_OPEN_FLEET_LIMIT,
      PermissionType.WRITE_ANY_OPEN_BOOKING_CONFIGURATION,
      PermissionType.POST_ANY_BREAK_POLICY,
      PermissionType.PATCH_ANY_BREAK_POLICY,
      PermissionType.DELETE_ANY_BREAK_POLICY,
    ],
    [FleetPermissionSet.Edit]: [
      PermissionType.PATCH_ANY_FLEET,
      PermissionType.WRITE_ANY_OPEN_FLEET_CONFIGURATION,
      PermissionType.WRITE_ANY_OPEN_FLEET_LIMIT,
      PermissionType.POST_ANY_BREAK_POLICY,
      PermissionType.PATCH_ANY_BREAK_POLICY,
      PermissionType.DELETE_ANY_BREAK_POLICY,
    ],
    [FleetPermissionSet.ForceEdit]: [
      PermissionType.WRITE_ANY_OPEN_FLEET_CONFIGURATION_FORCE,
    ],
  },
  unAssignablePermissionSets: [],
}
